/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { llmEvalsListSuites } from "../../funcs/llmEvalsListSuites.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.ListEvalSuitesRequest$inboundSchema,
};

export const tool$llmEvalsListSuites: ToolDefinition<typeof args> = {
  name: "llm-evals-list-suites",
  description: `List eval suites

Returns eval suites visible to the authenticated team context.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await llmEvalsListSuites(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
